import httpManager from "@/app/shared/utils/httpManager";
import {
  ReportTypes,
  PayPromiseReportTypes,
  PayPromiseReportTypesNames,
} from "@/app/reports/utils/enums";

export async function downloadList({ filters } = {}) {
  let query = "";
  if (filters.entity) query += `entity=${filters.entity}&`;
  query += `portfolio=${filters.portfolio}&`;
  if (filters.base) query += `base=${filters.base}&`;
  if (filters.user) query += `user=${filters.user}&`;
  query += `start_date=${filters.startDate}&`;
  query += `end_date=${filters.endDate}`;

  const pdp_type = PayPromiseReportTypesNames[PayPromiseReportTypes.List];

  const url = `/reports/${ReportTypes.PayPromise}/download/?pdp_type=${pdp_type}&${query}`;

  const response = await httpManager.post(url, {}, { blob: true });
  return response;
}
